import React from 'react';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import { SportsEsports, DashboardCustomize } from '@mui/icons-material';

export const ARCADE_SECTION_PARAM = 'section';
export const ARCADE_SECTIONS = {
    dashboard: 'dashboard',
    games: 'games',
};

export function arcadeHubPath(section = ARCADE_SECTIONS.dashboard) {
    const value = section === ARCADE_SECTIONS.games
        ? ARCADE_SECTIONS.games
        : ARCADE_SECTIONS.dashboard;
    return `/arcade?${ARCADE_SECTION_PARAM}=${value}`;
}

/**
 * Persistent Arcade Hub tabs (Dashboard | Games).
 * Always navigates to /arcade?section=… so hub chrome is never lost on Back/deep links.
 */
const ArcadeHubNav = ({ activeSection }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [searchParams] = useSearchParams();

    const resolvedSection = (() => {
        if (activeSection === ARCADE_SECTIONS.games || activeSection === ARCADE_SECTIONS.dashboard) {
            return activeSection;
        }
        if (location.pathname === '/arcade') {
            const fromUrl = searchParams.get(ARCADE_SECTION_PARAM);
            if (fromUrl === ARCADE_SECTIONS.games) return ARCADE_SECTIONS.games;
            return ARCADE_SECTIONS.dashboard;
        }
        // Sub-routes (dashboard deep links, replay) sit under the Dashboard hub section
        return ARCADE_SECTIONS.dashboard;
    })();

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 6 }}>
            <Tabs
                value={resolvedSection}
                onChange={(_, v) => navigate(arcadeHubPath(v))}
                sx={{
                    bgcolor: '#18181b',
                    border: '1px solid #333',
                    borderRadius: '12px',
                    minHeight: 0,
                    p: 0.5,
                    '& .MuiTabs-indicator': { display: 'none' },
                    '& .MuiTab-root': {
                        color: '#a1a1aa',
                        textTransform: 'none',
                        fontWeight: 600,
                        minHeight: 40,
                        borderRadius: '8px',
                        transition: 'all 0.2s',
                    },
                    '& .Mui-selected': {
                        color: '#0a0a0a !important',
                        bgcolor: '#2cbb5d',
                    },
                }}
            >
                <Tab
                    value={ARCADE_SECTIONS.dashboard}
                    label="Dashboard"
                    icon={<DashboardCustomize fontSize="small" />}
                    iconPosition="start"
                />
                <Tab
                    value={ARCADE_SECTIONS.games}
                    label="Games"
                    icon={<SportsEsports fontSize="small" />}
                    iconPosition="start"
                />
            </Tabs>
        </Box>
    );
};

export default ArcadeHubNav;
